import React from "react";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";

import { CustomIconsComponent } from "./CustomIcons";
import PageTitle from "@components/Common/PageTitle";
import NotAuthorizationPage from "@components/VerticalLayout/NotAuthorizationPage";
import CardSpinnerWrapper from "@components/Common/CardSpinnerWrapper";
import AccountIdentifier from "./AccountIdentifier";
import { useFetchGlobal } from "../../api/hooks";
import { useDispatch } from "react-redux";
import { setPays } from "../../redux/globalSlice";
import { useAuthHeader } from "../../api/headersKeycloak";
type CustomColumnProps = {
    indexOFColumn: number;
    columnName: string;
    customJsx: React.ReactNode;
};

export function TestAuto() {
    const dispatch = useDispatch();
    const getAuthHeader = useAuthHeader();
    const { fetchGlobal } = useFetchGlobal();

    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { t, i18n } = useTranslation();
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [isHaveAccess] = React.useState<boolean | number>(true);
    const [isLoading] = React.useState<boolean | number>(false);

    const uidEntity = "8ecfe5ee-926b-423e-8050-c911dd81c150-test-auto";
    const uuidUser = "411fe94c-c271-41b5-a877-bd7b9aa2ba0b";

    localStorage.setItem("uuidUser", "411fe94c-c271-41b5-a877-bd7b9aa2ba0b");

    async function getpays() {
        try {
            const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pays`;
            const data: any = await fetchGlobal(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": i18nextLng,
                },
                method: "GET",
            });

            if (data.error) {
                throw Error("Error!");
            }

            const listPays: any = [];
            data.data.forEach((element: any) => {
                listPays.push({
                    code: element.code,
                    label: element["Designation"],
                    value: element.Id,
                    frDesignation: element.frenchDesignation,
                });
            });
            dispatch(setPays(listPays));
        } catch (error) {
            console.log("error", error);
        }
    }
    const urlApiEntity = `${process.env.REACT_APP_ACCESS_API_URL}/entityv1/${uidEntity}/${uuidUser}`;
    localStorage.setItem("i18nextLng", i18n.language);
    React.useEffect(() => {
        setDataIsUpdated(true);
        getpays();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    let arrayOfCustomColumns: CustomColumnProps[] = [
        {
            indexOFColumn: 8,
            columnName: t("Identifier"),
            customJsx: AccountIdentifier,
        },
        {
            indexOFColumn: 99,
            columnName: t("Actions"),
            customJsx: (e: any) => {
                return <CustomIconsComponent e={e} />;
            },
        },
    ];
    return (
        <React.Fragment>
            <PageTitle title={t("Home")} />
            {isLoading === false ? (
                <div>
                    {isHaveAccess === false ? (
                        <NotAuthorizationPage />
                    ) : (
                        <div
                            className="page-content__clz"
                            style={{ width: "100%" }}
                        >
                            <h2 className="ml-5 mt-3">
                                {t("Choose an account")}
                            </h2>
                            <div
                                style={{ padding: "20px", margin: "9px" }}
                                className="card"
                            >
                                <DynamicTable
                                    url={
                                        `${process.env.REACT_APP_VERIFY}` ===
                                            "localhost" ||
                                        process.env.REACT_APP_VERIFY ===
                                            undefined
                                            ? "./user.json"
                                            : urlApiEntity
                                    }
                                    requestHeader={{
                                        "Accept-Language": i18n.language,
                                        ...getAuthHeader,
                                    }}
                                    canExpand={true}
                                    setDataIsUpdated={setDataIsUpdated}
                                    dataIsUpdated={dataIsUpdated}
                                    showFilter
                                    canSelect={false}
                                    setLocalFilterActive={setLocalFilterActive}
                                    filterActive={filterActive}
                                    actionColumn={() => <></>}
                                    arrayOfCustomColumns={arrayOfCustomColumns}
                                    canResize
                                    showGlobalFilter
                                    elevationTable={1}
                                    name="Choice"
                                    minHeight={"500px"}
                                    maxHeight={"500px"}
                                />
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <CardSpinnerWrapper />
            )}
        </React.Fragment>
    );
}
